import '@/assets/scss/sweetalerts.scss'
import Swal from 'sweetalert2'
import router from '@/router'

export async function modalGenericModel(
    title,
    message,
    icon,
    textButtonConfirm,
    textButtonCancel = null,
    allowClickOutside = false,
    customGeneralModalClass = false
  ){
    if(!document.querySelector('.modal-critical-error')){
      return await baseModalGenericModel(
        title,
        message,
        icon,
        textButtonConfirm,
        textButtonCancel,
        allowClickOutside,
        customGeneralModalClass ? 'modal-critical-error' : ''
      )
    }
  }

export const baseModalGenericModel = async (
  title,
  message,
  icon,
  textButtonConfirm,
  textButtonCancel,
  allowClickOutside,
  customGeneralModalClass
) => await Swal.fire(
  {
    width: 550,
    imageUrl: icon,
    imageWidth: 80,
    imageHeight: 80,
    title: title,
    html: message,
    showCancelButton: textButtonCancel != null,
    confirmButtonText: textButtonConfirm,
    cancelButtonText: textButtonCancel,
    reverseButtons: true,
    allowOutsideClick: allowClickOutside,
    customClass: {
      popup: customGeneralModalClass,
      confirmButton: 'btn btn-primary mb-1',
      cancelButton: "btn btn-outline-secondary mr-1 mb-1"
    },
    buttonsStyling: false
  }
)


export const modalGenericFillableError = async (message, prioritario = true) => {
  await modalGenericModel(
    'Erro',
    message,
    require('@/assets/custom-icons/cora-icons/error.png'),
    'Ok',
    null,
    false,
    prioritario
  )
}

export const modalGenericFillableErrorWithReload = async (message, prioritario = true) => {
  await modalGenericModel(
    'Erro',
    message,
    require('@/assets/custom-icons/cora-icons/error.png'),
    'Ok',
    null,
    false,
    prioritario
  ).then(() => {
    window.location.reload()
  })
}

export const modalGenericFillableErrorWithRedirectHome = async (message, prioritario = true) => {
  await modalGenericModel(
    'Erro',
    message,
    require('@/assets/custom-icons/cora-icons/error.png'),
    'Ok',
    null,
    false,
    prioritario
  ).then(() => {
    router.push(
      {
        name: 'bem-vindo'
      }
    );
  })
}

export const modalGenericErrorWithRedirectHome = async () => {
  await modalGenericModel(
    'Ocorreu um erro!',
    'Ocorreu um erro de conexão com nossa base de dados. Por favor, tente novamente mais tarde ou contate nosso suporte.',
    require('@/assets/custom-icons/cora-icons/error.png'),
    'Ok',
    null,
    false,
    true
  ).then(() => {
    router.push(
      {
        name: 'bem-vindo'
      }
    );
  });
}
